import { Button, Text, ThemeCss } from "gatsby-interface"
import * as React from "react"

export type StarterCardProps = {
  onHandleChoice: () => void
  image: string
  title: string
  icon?: JSX.Element
}

// Styling
const buttonCss: ThemeCss = theme => ({
  fontSize: theme.fontSizes[0],
  margin: theme.space[0],
  padding: theme.space[0],
  border: `none`,
  background: theme.colors.white,
  display: `flex`,
  flexDirection: `column`,
  width: `100%`,
  height: "100%",
  borderRadius: theme.space[2],
  boxShadow: `0px 2px 4px rgba(71, 63, 79, 0.08), 0px 1px 2px rgba(46, 41, 51, 0.08)`,
  "&:hover": {
    transform: `translateY(-${theme.space[2]})`,
    background: `none`,
    border: `none`,
    boxShadow: theme.shadows.overlay,
  },
  "&:focus": {
    transform: `translateY(-${theme.space[2]})`,
    background: `none`,
    border: `none`,
    boxShadow: theme.shadows.overlay,
  },
})

export const cardInfoCss: ThemeCss = theme => ({
  display: `flex`,
  alignSelf: `stretch`,
  whiteSpace: "nowrap",
  justifyContent: `space-between`,
  height: `32px`,
  borderTop: `1px solid ${theme.colors.grey[20]}`,
  marginTop: `auto`,
  padding: theme.space[3],
  fontSize: theme.fontSizes[0],
  color: theme.colors.grey[90],
  alignItems: `center`,
})

export default function StarterCard({
  onHandleChoice,
  image,
  title,
  icon,
}: StarterCardProps) {
  return (
    <Button
      onClick={onHandleChoice}
      onKeyPress={onHandleChoice}
      css={buttonCss}
    >
      <div
        css={{
          backgroundSize: `cover`,
          backgroundImage: `url(${image})`, // left these styles inline to allow image to be passed in
          borderRadius: `0.25rem 0.25rem 0 0`,
          width: `100%`,
          paddingTop: `56.25%`, // approach to maintain the aspect ratio
          height: `0px`,
        }}
      ></div>
      <div css={cardInfoCss}>
        <Text
          css={{
            fontSize: `12px`,
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "left",
          }}
          noMarginBottom
          tone="NEUTRAL"
          variant="EMPHASIZED"
        >
          {title}
        </Text>
        {icon ? icon : null}
      </div>
    </Button>
  )
}
